<template>
    <div class="page-container">
        <span class="name"
            >{{ pageData.brandName }}&nbsp;&nbsp;&nbsp;&nbsp;窝窝投</span
        >
        <div class="header-box">
            <img class="avatar" :src="pageData.brandLogo" />
            <img class="icon-feiji" src="../assets/czsm/feiji.png" />
            <img class="icon-miantiao" src="../assets/czsm/miaotiao.png" />
            <img class="icon-hanbao" src="../assets/czsm/hanbao.png" />
            <img class="icon-sq" src="../assets/czsm/shouqiang.png" />
            <img class="chwl" src="../assets/czsm/chwl.png" />
        </div>
        <!-- 探店 -->
        <div
            class="xsth-box"
            v-if="pageData.tanDianTasks && pageData.tanDianTasks.length > 0"
        >
            <img class="icon-xsth" src="../assets/czsm/xsth.png" />
            <div
                class="item"
                v-for="item in pageData.tanDianTasks"
                :key="`tanDianTasks-item-key-${item.id}`"
            >
                <div class="bg"></div>
                <div class="img-box">
                    <img
                        style="width: 100px; height: 100px"
                        :src="item.imgShow"
                    />
                </div>
                <div class="content-box">
                    <span class="title">{{ item.productName || "商品" }}</span>
                    <div class="money">
                        <span>￥&nbsp;{{ item.price }}</span>
                        <img
                            style="width: 45px"
                            src="../assets/czsm/zengsong.png"
                        />
                    </div>
                    <span v-if="item.amount" class="other"
                        >再送{{ item.amount }}元现金</span
                    >
                    <span class="content-sure-btn" @click="handleOpenApp"
                        >去APP报名</span
                    >
                </div>
            </div>
        </div>
        <!-- 推广 -->
        <div
            class="jiangjin-box"
            v-if="
                pageData.popularizeTasks && pageData.popularizeTasks.length > 0
            "
        >
            <img class="icon-dsnjj" src="../assets/czsm/dsnjj.png" />
            <div
                class="item"
                v-for="(item, index) in pageData.popularizeTasks"
                :key="`popularizeTasks-item-key-${item.id}`"
            >
                <span class="title">{{ item.taskName || "无" }}</span>
                <span class="money">￥&nbsp;{{ item.amount }}</span>
                <template v-if="item.productName || item.img || item.price">
                    <span class="info" v-if="item.price">再赠送商品</span>
                    <div class="product-box">
                        <img
                            style="
                                width: 40px;
                                height: 40px;
                                border-radius: 6px;
                            "
                            :src="item.imgShow"
                        />
                        <div class="product-info">
                            <span class="product-name">{{
                                item.productName || "无"
                            }}</span>
                            <span class="product-money"
                                >￥&nbsp;{{ item.price }}</span
                            >
                        </div>
                    </div>
                </template>
                <div
                    class="line"
                    v-if="index < pageData.popularizeTasks.length - 1"
                ></div>
            </div>
        </div>
        <!-- 推荐 -->
        <div
            class="other-box"
            v-if="pageData.recommendTasks && pageData.recommendTasks.length > 0"
        >
            <img class="icon-qtrmxm" src="../assets/czsm/qtrmxm.png" />
            <div
                class="item"
                v-for="item in pageData.recommendTasks"
                :key="`recommendTasks-item-key-${item.id}`"
            >
                <span class="title">{{ item.taskName }}</span>
                <div class="box">
                    <span class="money">￥&nbsp;{{ item.amount }}</span>
                    <!--                    <span class="sure-btn" @click="handleOpenApp">去APP报名</span>-->
                </div>
            </div>
        </div>
        <span class="sure-btn" @click="handleOpenApp">去APP报名</span>
    </div>
    <!--    <div class="box">-->
    <!--        &lt;!&ndash;        <img src="../assets/zt/bg2.png" alt="" class="img" />&ndash;&gt;-->
    <!--        &lt;!&ndash;        <img class="brand_img" :src="`https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${data.brandLogo}`" />&ndash;&gt;-->
    <!--        <img-->
    <!--            class="brand_img"-->
    <!--            src="https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/business_license/1426814422907478017.jpeg"-->
    <!--        />-->
    <!--&lt;!&ndash;        <img class="person_img" src="../assets/zt/person.png" alt="" />&ndash;&gt;-->
    <!--        <img class="hamburger" src="../assets/zt/hamburger.png" />-->
    <!--        <div class="header">-->
    <!--            <span class="header_left">{{ data.brandName }}</span>-->
    <!--            <span class="header_centen">&nbsp;x</span>-->
    <!--            <span class="header_right">Waaoh</span>-->
    <!--        </div>-->
    <!--        <div class="discount_wrapper">-->
    <!--            <div-->
    <!--                class="discount"-->
    <!--                v-for="item in data.tanDianTasks"-->
    <!--                :key="item.id"-->
    <!--            >-->
    <!--                <div class="discount_img">-->
    <!--                    <img-->
    <!--                        :src="-->
    <!--                            `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.img}`-->
    <!--                        "-->
    <!--                    />-->
    <!--                </div>-->
    <!--                <div class="discount_info">-->
    <!--                    <p class="discount_title">-->
    <!--                        {{ item.productName ? item.productName : '无' }}-->
    <!--                    </p>-->
    <!--                    <p>-->
    <!--                        <span class="good_price">¥&nbsp;{{ item.price }}</span>-->
    <!--                        <span class="good_status">免费赠送</span>-->
    <!--                    </p>-->
    <!--                    <van-button class="apply apply-small">去App报名</van-button>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="bonus_wrapper">-->
    <!--            <div-->
    <!--                class="bonus"-->
    <!--                v-for="item in data.popularizeTasks"-->
    <!--                :key="item.id"-->
    <!--            >-->
    <!--                <div class="box2">-->
    <!--                    <p class="discount_title">超级喵小红书推广,200元免费领</p>-->
    <!--                    <span class="good_price">¥&nbsp;200</span>-->
    <!--                    <p class="box2_p2">再赠送商品</p>-->
    <!--                    <div class="box2_div">-->
    <!--                        <img-->
    <!--                            class="box2_div_img"-->
    <!--                            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7087de8b9e3e7da9e8bef3cd4a9de210249e3521befed3f32b2f5dc9ab1f3d85"-->
    <!--                            alt=""-->
    <!--                        />-->
    <!--                        <div class="box2_div2">-->
    <!--                            <p class="box2_div2_p">超级喵冰砖系列</p>-->
    <!--                            <span class="box2_div2_span">¥&nbsp;200</span>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                    <p class="box2_xian"></p>-->
    <!--                    <p class="discount_title">超级喵小红书推广,200元免费领</p>-->
    <!--                    <p class="good_price">¥&nbsp;200</p>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <div class="hot-wrapper common-wrapper">-->
    <!--            <div-->
    <!--                class="hot common-card"-->
    <!--                v-for="item in data.recommendTasks"-->
    <!--                :key="item.id"-->
    <!--            >-->
    <!--                <p class="discount_title">{{item.productName}}</p>-->
    <!--                <p>-->
    <!--                    <span class="good_price">￥ {{item.price}}</span>-->
    <!--                    <van-button class="apply apply-small">去App报名</van-button>-->
    <!--                </p>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--        <van-button class="apply apply_large">去App报名</van-button>-->
    <!--    </div>-->
</template>

<script>
import { fetchTableSticker } from "@/services/task";
import round from "lodash.round";

export default {
    data() {
        return {
            pageData: {},
        };
    },
    methods: {
        trigger() {
            if (this.$route.query && this.$route.query.brandId) {
                const brandId = this.$route.query.brandId;
                fetchTableSticker(brandId).then((res) => {
                    console.log(res);
                    res.brandLogo = `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${res.brandLogo}`;
                    res.popularizeTasks.forEach((item) => {
                        console.log(item.img);
                        item.imgShow = `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.img}`;
                        item.price = round(item.price / 100);
                        item.amount = round(item.amount / 100);
                    });
                    res.recommendTasks.forEach((item) => {
                        item.imgShow = `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.img}`;
                        item.price = round(item.price / 100);
                        item.amount = round(item.amount / 100);
                    });
                    res.tanDianTasks.forEach((item) => {
                        item.imgShow = `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item.img}`;
                        item.price = round(item.price / 100);
                        item.amount = round(item.amount / 100);
                    });
                    this.pageData = res;
                });
            }
        },
        handleOpenApp() {
            this.$router.push({ path: "/download" });
        },
    },
    mounted() {
        this.trigger();
    },
};
</script>

<style scoped lang="less">
.page-container {
    background-image: url("../assets/czsm/bg.png");
    background-position: 0 0;
    background-size: 100% 100%;
    width: 100vw;
    min-height: 100vh;
    padding-bottom: 88px;
    .name {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 25px;
        padding: 10px 15px;
        display: block;
    }
    .header-box {
        text-align: right;
        position: relative;
        padding-top: 60px;
        .avatar {
            width: 70px;
            height: 70px;
            position: absolute;
            border-radius: 100%;
        }
        .chwl {
            width: 320px;
            text-align: center;
            margin-right: 16px;
        }
        .icon-feiji {
            width: 83px;
            position: absolute;
            top: 0;
            left: 30%;
        }
        .icon-miantiao {
            width: 30px;
            position: absolute;
            bottom: 0;
            left: 0;
        }
        .icon-hanbao {
            position: absolute;
            left: 66px;
            bottom: -40px;
            width: 44px;
        }
        .icon-sq {
            width: 112px;
            position: absolute;
            right: 24px;
            bottom: -114px;
            z-index: 0;
        }
    }
    .xsth-box {
        padding: 10px;
        margin-top: 100px;
        z-index: 2;
        position: relative;
        .icon-xsth {
            position: absolute;
            top: -24px;
            left: 30px;
            width: 160px;
            z-index: 10;
        }
        .item {
            height: 160px;
            margin: 0 10px;
            position: relative;
            display: flex;
            margin-top: 26px;
            &:first-of-type {
                margin-top: 0;
            }
            .bg {
                background: linear-gradient(180deg, #ffd151 0%, #ffffff 100%);
                box-shadow: 0px 4px 12px 0px #fa6400;
                border-radius: 10px;
                transform: skewX(-8deg);
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
            }
            .img-box {
                width: 150px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                position: relative;
                text-align: right;
                img {
                    margin-right: 16px;
                    border-radius: 6px;
                }
            }
            .content-box {
                flex: 1;
                position: relative;
                padding-top: 30px;
                .title {
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: bold;
                    color: #171f24;
                    line-height: 21px;
                }
                .money {
                    padding-top: 10px;
                    padding-bottom: 4px;
                    font-size: 20px;
                    font-family: Arial-Black, Arial;
                    font-weight: 900;
                    color: #fa6400;
                    line-height: 21px;
                }
                .other {
                    font-size: 10px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #5d5d5e;
                    line-height: 16px;
                }
                .content-sure-btn {
                    margin-top: 20px;
                    width: 80px;
                    font-size: 12px;
                    height: 29px;
                    font-family: PingFangHK-Regular, PingFangHK;
                    font-weight: 400;
                    line-height: 29px;
                    color: #ffffff;
                    box-shadow: none;
                    position: unset;
                    display: block;
                    background: linear-gradient(
                        180deg,
                        #ff6d26 0%,
                        #f7b500 100%
                    );
                    border-radius: 5px;
                    text-align: center;
                    float: right;
                    margin-right: 20px;
                }
            }
        }
    }
    .jiangjin-box {
        margin: 60px 15px 0;
        padding: 30px 15px 13px;
        background: linear-gradient(360deg, #ffe6a1 0%, #ffd151 100%);
        box-shadow: 0px 4px 12px 0px #fa6400;
        border-radius: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        .icon-dsnjj {
            position: absolute;
            width: 180px;
            top: -34px;
            right: 0;
        }
        .item {
            display: flex;
            flex-direction: column;
            .title {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #171f24;
                line-height: 21px;
                margin-bottom: 10px;
            }
            .money {
                font-size: 18px;
                font-family: Arial-Black, Arial;
                font-weight: bolder;
                color: #fa6400;
                line-height: 21px;
                margin-bottom: 14px;
            }
            .info {
                font-size: 10px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #5d5d5e;
                line-height: 16px;
                margin-bottom: 14px;
            }
            .product-box {
                height: 40px;
                display: flex;
                .product-info {
                    padding-left: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .product-name {
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: bold;
                        color: #171f24;
                    }
                    .product-money {
                        font-size: 12px;
                        font-family: Arial-Black, Arial;
                        font-weight: 900;
                        color: #fa6400;
                    }
                }
            }
        }
        .line {
            height: 20px;
            border-bottom: 2px dashed #cbc8c8;
            margin-bottom: 16px;
        }
    }
    .other-box {
        margin: 60px 15px 28px;
        padding: 30px 15px 13px;
        background: linear-gradient(360deg, #ffe6a1 0%, #ffd151 100%);
        box-shadow: 0px 4px 12px 0px #fa6400;
        border-radius: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        .icon-qtrmxm {
            width: 180px;
            position: absolute;
            top: -40px;
            left: 0;
        }
        .item {
            display: flex;
            flex-direction: column;
            padding-bottom: 10px;
            .title {
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #171f24;
                line-height: 21px;
                margin-bottom: 10px;
            }
            .box {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .money {
                font-size: 18px;
                font-family: Arial-Black, Arial;
                font-weight: bolder;
                color: #fa6400;
                line-height: 21px;
            }
            .sure-btn {
                margin: 0;
                width: 80px;
                font-size: 12px;
                height: 29px;
                font-family: PingFangHK-Regular, PingFangHK;
                font-weight: 400;
                line-height: 29px;
                color: #ffffff;
                box-shadow: none;
            }
        }
    }
    .sure-btn {
        display: block;
        width: 246px;
        height: 53px;
        background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.5);
        border-radius: 5px;
        font-size: 17px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 1px;
        text-align: center;
        line-height: 53px;
        position: fixed;
        bottom: 30px;
        left: 50%;
        margin-left: -123px;
        z-index: 100;
        &:active {
            opacity: 0.8;
        }
    }
}
</style>
<!--<style lang="less" scoped>-->
<!--.box {-->
<!--    background-image: url('../assets/zt/bg2.png');-->
<!--    background-position: 0 0;-->
<!--    background-repeat: no-repeat;-->
<!--    background-size: 100% 100%;-->
<!--    width: 100%;-->
<!--    height: 100vh;-->
<!--    //height: 900px;-->
<!--    position: relative;-->
<!--    overflow-x: hidden;-->
<!--    p {-->
<!--        margin: 0;-->
<!--        padding-top: 5px;-->
<!--        padding-bottom: 5px;-->
<!--    }-->
<!--    .good_price {-->
<!--        color: #fa6400;-->
<!--        font-size: 20px;-->
<!--        font-weight: 800;-->
<!--    }-->
<!--    .discount_title {-->
<!--        font-weight: 500;-->
<!--        font-size: 16px;-->
<!--    }-->
<!--    .brand_img {-->
<!--        position: fixed;-->
<!--        top: 120px;-->
<!--        left: 20px;-->
<!--        width: 80px;-->
<!--        height: 80px;-->
<!--        border-radius: 80px;-->
<!--    }-->
<!--}-->
<!--.header {-->
<!--    position: fixed;-->
<!--    top: 0;-->
<!--    width: 100%;-->
<!--    padding-left: 20px;-->
<!--    line-height: 40px;-->
<!--    font-size: 18px;-->
<!--    color: #ffffff;-->
<!--    .header_centen {-->
<!--        margin: 0 5px;-->
<!--    }-->
<!--}-->
<!--.apply {-->
<!--    background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);-->
<!--    border-radius: 5px;-->
<!--    color: #fff;-->
<!--    border: none;-->
<!--    &.apply-small {-->
<!--        float: right;-->
<!--        margin-top: 10px;-->
<!--        height: 30px;-->
<!--    }-->
<!--    &.apply_large {-->
<!--        display: block;-->
<!--        margin: 20px auto;-->
<!--        width:247px;-->
<!--        height:57px;-->
<!--    }-->
<!--}-->
<!--.discount_wrapper {-->
<!--    position: relative;-->
<!--    &:before {-->
<!--        content: '';-->
<!--        //background: url('../assets/zt/limit.png') no-repeat;-->
<!--        background-size: 100% auto;-->
<!--        width: 159px;-->
<!--        height: 48px;-->
<!--        position: absolute;-->
<!--        left: 30px;-->
<!--        top: -30px;-->
<!--    }-->
<!--    .discount {-->
<!--        background: url('https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge7da155e76d9e5b2cc3e8a794f52c211dfbe18426d008906539048dadae8a626')-->
<!--            no-repeat;-->
<!--        background-size: 100% 100%;-->
<!--        display: flex;-->
<!--        padding: 30px 50px 50px 30px;-->
<!--        .discount_img {-->
<!--            display: flex;-->
<!--            img {-->
<!--                width: 80px;-->
<!--                height: 80px;-->
<!--                margin-right: 15px;-->
<!--            }-->
<!--        }-->
<!--        .discount_info {-->
<!--            flex: 1;-->
<!--            .good_price {-->
<!--                color: red;-->
<!--                font-size: 20px;-->
<!--                font-weight: 800;-->
<!--            }-->
<!--            .good_status {-->
<!--                padding: 3px 12px;-->
<!--                background: red;-->
<!--                border-radius: 0 16px 0 16px;-->
<!--                color: #ffffff;-->
<!--                font-size: 12px;-->
<!--                margin-left: 5px;-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--}-->
<!--.bonus_wrapper {-->
<!--    position: relative;-->
<!--    margin-top: 60px;-->
<!--    &:before {-->
<!--        content: '';-->
<!--        //background: url('../assets/zt/ds.png') no-repeat;-->
<!--        background-size: 100% auto;-->
<!--        width: 180px;-->
<!--        height: 48px;-->
<!--        position: absolute;-->
<!--        right: 17px;-->
<!--        top: -46px;-->
<!--    }-->
<!--    .bonus {-->
<!--        width: 344px;-->
<!--        margin: 0 auto;-->
<!--        box-sizing: border-box;-->
<!--        border-radius: 10px;-->
<!--        //background-size: 100% 100%;-->
<!--        //position: absolute;-->
<!--        //top: 70px;-->
<!--        //left: 16px;-->
<!--        background-image: linear-gradient(#ffe6a1, #ffd151);-->
<!--        padding: 20px 10px;-->
<!--        .box2 {-->
<!--            .box2_p {-->
<!--                width: 239px;-->
<!--                height: 21px;-->
<!--                font-size: 16px;-->
<!--                color: #171f24;-->
<!--                line-height: 21px;-->
<!--                font-weight: 600;-->
<!--            }-->
<!--            .box2_span {-->
<!--                width: 56px;-->
<!--                height: 21px;-->
<!--                font: 18px;-->
<!--                color: #fa6400;-->
<!--                font-weight: 800;-->
<!--            }-->
<!--            .box2_p2 {-->
<!--                width: 60px;-->
<!--                height: 16px;-->
<!--                font-size: 10px;-->
<!--                color: #5d5d5e;-->
<!--                margin: 14px 0 13px 0;-->
<!--            }-->
<!--            .box2_div {-->
<!--                display: flex;-->
<!--                .box2_div_img {-->
<!--                    width: 40px;-->
<!--                    height: 40px;-->
<!--                    margin-right: 10px;-->
<!--                }-->
<!--                .box2_div2_p {-->
<!--                    margin: 0;-->
<!--                    width: 88px;-->
<!--                    height: 21px;-->
<!--                    font-size: 12px;-->
<!--                    color: #171f24;-->
<!--                }-->
<!--                .box2_div2_span {-->
<!--                    font-size: 12px;-->
<!--                    color: #fa6400;-->
<!--                    font-weight: 800;-->
<!--                }-->
<!--            }-->
<!--            .box2_xian {-->
<!--                border-bottom: 1px dashed #cbc8c8;-->
<!--                margin: 19px 0 17px 0;-->
<!--                padding: 0;-->
<!--            }-->
<!--            .box2_botton {-->
<!--                width: 240px;-->
<!--                height: 21px;-->
<!--                line-height: 21px;-->
<!--                font-size: 16px;-->
<!--                color: #171f24;-->
<!--                font-weight: 600;-->
<!--            }-->
<!--            .box2_bottom2 {-->
<!--                width: 60px;-->
<!--                height: 21px;-->
<!--                font-weight: 800;-->
<!--                color: #fa6400;-->
<!--                font-size: 18px;-->
<!--                margin-top: 5px;-->
<!--            }-->
<!--        }-->
<!--    }-->
<!--}-->
<!--.common-wrapper {-->
<!--    position: relative;-->
<!--    margin-top: 60px;-->
<!--    .common-card {-->
<!--        box-sizing: border-box;-->
<!--        padding: 20px 10px;-->
<!--        border-radius: 10px;-->
<!--        width: 344px;-->
<!--        background-image: linear-gradient(#ffe6a1, #ffd151);-->
<!--    }-->
<!--}-->
<!--.hot-wrapper {-->
<!--    position: relative;-->
<!--    &:before {-->
<!--        content: '';-->
<!--        //background: url('../assets/zt/hot.png') no-repeat;-->
<!--        background-size: 100% auto;-->
<!--        width: 180px;-->
<!--        height: 48px;-->
<!--        position: absolute;-->
<!--    }-->
<!--    .hot {-->
<!--        margin: 0 auto 20px;-->
<!--        border-radius: 10px;-->
<!--        width: 344px;-->
<!--        background-image: linear-gradient(#ffe6a1, #ffd151);-->
<!--    }-->
<!--}-->
<!--.hamburger {-->
<!--    position: fixed;-->
<!--    top: 302px;-->
<!--    left: 70px;-->
<!--    width: 44px;-->
<!--    height: 37px;-->
<!--}-->
<!--.person_img {-->
<!--    position: absolute;-->
<!--    top: 294px;-->
<!--    left: 237px;-->
<!--    width: 113px;-->
<!--    height: 128px;-->
<!--}-->
<!--</style>-->
